const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const Switch = require('../../../Switch/B');
const useFormCtx = require('../../utils/useFormCtx');

module.exports = ({label: manualLabel, className, disableLabel, ...props}) => {
  const {
    name,
    value,
    onChange,
    disabled
  } = useFormCtx(props);

  const label = disableLabel
    ? ''
    : manualLabel
      ? manualLabel
      : name
        ? name.split('_').map(upperFirst).join(' ')
        : '';

  return (
    <Switch
      label={!disableLabel && {name: label, className: 'f16-i ttU c0 fw4'}}
      className={className}
      checked={value}
      onChange={(val) => onChange(name, val)}
      disabled={disabled}
    />
  )
}
